enum RuuviTagConditionAggregateInterval {
  FIVE_MINUTES = '5min',
  FIFTEEN_MINUTES = '15min',
  ONE_HOUR = '1h',
  ONE_DAY = '1d'
}

export default RuuviTagConditionAggregateInterval
